import { render } from "./RoleFieldEditable.vue?vue&type=template&id=3397c4e2&scoped=true"
import script from "./RoleFieldEditable.vue?vue&type=script&lang=js"
export * from "./RoleFieldEditable.vue?vue&type=script&lang=js"

import "./RoleFieldEditable.vue?vue&type=style&index=0&id=3397c4e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3397c4e2"]])

export default __exports__